import React, { FC, ReactNode } from 'react';

import { SideBarContext } from '../../context/side-bar-context';
import SideBar from '../side-bar/side-bar';

export type SideBarLayoutProps = { children: ReactNode };

const SideBarLayout: FC<SideBarLayoutProps> = ({ children }) => (
  <SideBarContext>
    <div className="flex h-full w-full">
      <SideBar />
      {children}
    </div>
  </SideBarContext>
);

SideBarLayout.displayName = 'SideBarLayout';

export default SideBarLayout;
